import src from "IMAGE";
export default { src, width: 86, height: 92, blurWidth: 0, blurHeight: 0};
